import type { GetUserInfoParams } from './types'

export const UserEndpoints = {
  getInfo: ({ userId, slug }: GetUserInfoParams) => `/rest/v3/users/me/${userId}/slug/${slug}`,
  join: () => '/rest/v1/users/join',
  create: () => '/api/v1/users/createProfile'
}
